import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { EnvToken } from '@app/core/env.tokens';
import { NgOptimizedImage } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ExternalService } from '@app/services/http/external.service';
@Component({
  selector: 'app-happy-helper-usps',
  standalone: true,
  imports: [MatIconModule, TranslateModule, NgOptimizedImage],
  templateUrl: './happy-helper-usps.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./happy-helper-usps.component.scss'],
})
export class HappyHelperUspsComponent {
  protected readonly env = inject(EnvToken);

  readonly happyHelperCode: string = 'handyhand2025';
  happyHelperWorker = `${this.env.cloudFrontImgUrl}/private/happy_helper_worker-min.png`;

  constructor(public externalService: ExternalService) {}

  goToUserHappyHelper(): void {
    if (typeof window !== 'undefined') {
      window.open(
        'https://happyhelper.dk?utm_medium=website_landingpage&utm_source=handyhand&utm_campaign=happy_handy_colab',
        '_blank',
      );
    }
  }
}
